import { Feature, MultiPolygon, Polygon } from "geojson";
import turf from "../../../shared/utils/turf";

export function polygonToBbox(
  bufferPolygon: Feature<Polygon | MultiPolygon>,
  map: mapboxgl.Map,
): [mapboxgl.Point, mapboxgl.Point] {
  const bbox = turf.bbox(bufferPolygon);
  const [minLng, minLat, maxLng, maxLat] = bbox;
  const sw = map.project([minLng, minLat]);
  const ne = map.project([maxLng, maxLat]);
  return [sw, ne];
}
